import { Modal, Form, Radio, Input, Space } from 'antd';
import { useState, useEffect } from 'react';

export type VerifyItem = { ids: number[]; isVerified: boolean; verifiedComment?: string };

const useVerified = (handleVerify: (data: VerifyItem) => Promise<boolean>) => {
  const [visible, setVisible] = useState(false);
  const [ids, setId] = useState<number[]>([]);

  const [form] = Form.useForm<{ isVerified: boolean; verifiedComment: string }>();

  const isVerified = Form.useWatch('isVerified', form);

  useEffect(() => {
    if (ids.length) setVisible(true);
  }, [ids]);

  function clear() {
    setVisible(false);
    setId([]);
    form.setFieldsValue({ isVerified: true, verifiedComment: '' });
  }

  return {
    E: <Modal
      title="复核"
      visible={visible}
      onCancel={clear}
      onOk={form.submit}
    >
      <Space direction="vertical">
        <Form
          form={form}
          initialValues={{ isVerified: true }}
          onFinish={async (values) => {
            const result = await handleVerify({ ...values, ids });
            if (result) clear();
          }}
        >
          <Form.Item label="是否复核通过" name="isVerified">
            <Radio.Group>
              <Radio value={true}>是</Radio>
              <Radio value={false}>否</Radio>
            </Radio.Group>
          </Form.Item>
          {
            !isVerified && <Form.Item label="复核建议" name="verifiedComment" rules={[{ required: true, message: "请填写复核建议！" }]}>
              <Input />
            </Form.Item>
          }
        </Form>
        <h4>注：没有权限操作的问答，即使被勾选，也会被剔除；</h4>
      </Space>
    </Modal>,
    controller: {
      clear,
      setId,
    }
  }
}

export default useVerified;
